
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { getFileToken } from "../../../api/user";
import { directUploadFile, previewImage } from "@/utils/util";
import { dataType } from "./feedBack";
import { Toast ,ImagePreview} from 'vant'
import { useRoute ,useRouter} from "vue-router";
import {getOrderDetailApi,postFeedApi,getFeedApi} from "../../../api/production";
import router from "@/router";
function setData() {
  return {
    imageList: [],
    name: "",
    count: "",
    croperName: "", 
    farmer: "",
    date: "",
    order: "",
    remark:"",
    feedMan: "",
    phone: '',
    unit:'',
    type:1,
    feedId:'',
    createTime:'',
    code : ''
  };
}
export default defineComponent({
  setup() {
    const state = reactive<dataType>(setData());
    const { imageUploadAfter, onDeleteImg, onClickImgPoster,onPreviewImg } = useEvent(state);
    const { getOrderInfo,postInfo,getFeed } = useApi(state,router)
    onMounted(()=>{
      const route = useRoute() as any
      const router = useRouter() as any
      if(route.query.feedId){
        state.type=2
        state.feedId = route.query.feedId
        getFeed()
      }else{
        state.order = route.query.orderId
        state.boxId = route.query.boxId
        state.type=1
        getOrderInfo()
      }
    })
    return {
      ...toRefs(state),
      imageUploadAfter,
      onClickImgPoster,
      onDeleteImg,
      getOrderInfo,
      postInfo,
      getFeed,
      onPreviewImg
    };
  },
});
const useEvent = (state: dataType) => {
  const imageUploadAfter = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        const result: any = await getFileToken({
          bucket: "xfarmer",
          fileType: 0,
          type: 2,
          token: localStorage.getItem("token"),
        });
        if (result.data.code == 0) {
          // 执行该函数后，获取数据请直接从双向绑定的数组中取值.
          directUploadFile(item, result.data);
        }
      });
    } else {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: 0,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(e, result.data);
      }
    }
  };
  const onClickImgPoster = (item: any) => {
    previewImage(
      state.imageList.map((item: any) => item.poster),
      item.index
    );
  };
  const onDeleteImg = (item: any) => {
    state.imageList.splice(item.index, 1);
  };
  const onPreviewImg = (item: any, v: Array<any>) => {
    let temp = v.map((items: any) => {
      return items.url;
    });
    ImagePreview({
      images: temp,
      startPosition: item.tempIndex,
    });
  };
  return {
    onPreviewImg,
    imageUploadAfter,
    onDeleteImg,
    onClickImgPoster,
  };
};
const useApi = (state:dataType,router:any) =>{
  const getOrderInfo = ()=>{
    let obj = {
      ledger:state.order,
      box:state.boxId
    }
      getOrderDetailApi(obj).then((res:any)=>{
        let data = res.data.data
         state.unit = data.unit
         state.name= data.productName,
         state.count= data.number,
         state.croperName= data.cooperationName,
         state.farmer=data.farmerName,
         state.date= data.ledgerTime
        
      });
  }
  const postInfo = ()=>{
    if(!state.feedMan){
        Toast('请输入反馈人姓名')
      return
    }
    if(!state.phone){
        Toast('请输入手机号')
      return
    }
    if(String(state.phone).length<11){
        Toast('请输入正确的手机号')
      return
    }
    let imgIds = ''
     state.imageList.forEach((item:any)=>{
       imgIds += item.id +','
    })
    imgIds = imgIds.substring(0,imgIds.length-1)
    let obj = {
      name:state.feedMan,
      imgIds,
      phoneNumber:state.phone,
      content:state.remark,
      ledgerId:state.order,
      boxId:state.boxId,
      productName:state.name,
      number:state.count, 
      cooperationName:state.croperName,
      farmerName:state.farmer,
      ledgerDate:state.date,
      unit:state.unit
    }
    postFeedApi(obj).then((res:any)=>{
      if(res.data.code == 0){
        Toast('提交成功')
        setTimeout(()=>{
          router.push('/feedBackOk')
        })
      }
    })
  }
  const getFeed = ()=>{
    
    getFeedApi(state.feedId).then((res:any)=>{
      let data = res.data.data
         state.unit = data.unit
         state.name= data.productName,
         state.count= data.number,
         state.croperName= data.cooperationName,
         state.farmer=data.farmerName,
         state.date= data.ledgerDate,
         state.order = data.ledgerId
         state.phone = Number(data.phoneNumber) 
         state.remark = data.content
         state.feedMan = data.name
         state.imageList = data.imgList
         state.createTime = data.createTime
         state.imageList = state.imageList.map((item: any, index: number) => {
          item.tempIndex = index;
          return item;
        });
    })
  }
  return {
    getOrderInfo,
    postInfo,
    getFeed
  }
}
